var map = {
	"./france.amboise.chateau/immgrandesalle": "8198",
	"./france.amboise.chateau/immgrandesalle.json": "8198",
	"./france.chinon.forteresse/cuisine": "5d51",
	"./france.chinon.forteresse/cuisine.json": "5d51",
	"./france.chinon.forteresse/prisondestempliers": "87e9",
	"./france.chinon.forteresse/prisondestempliers.json": "87e9",
	"./france.chinon.forteresse/tourartillerie": "cdba",
	"./france.chinon.forteresse/tourartillerie.json": "cdba",
	"./france.chinon.forteresse/tourdumoulin": "bb89",
	"./france.chinon.forteresse/tourdumoulin.json": "bb89",
	"./france.loches.donjon/carriere": "f4ad",
	"./france.loches.donjon/carriere.json": "f4ad",
	"./france.loches.donjon/cellier": "d431",
	"./france.loches.donjon/cellier.json": "d431",
	"./france.loches.donjon/courchateau": "55f7",
	"./france.loches.donjon/courchateau.json": "55f7",
	"./france.paris.pcv-versailles/sallonapollon": "7563",
	"./france.paris.pcv-versailles/sallonapollon.json": "7563"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5dea";